Librarian.Cart = new Class({
    Binds: ["onUpdate", "insertBefore", "doInsertBefore"],

    // Fired when the cart is updated. Takes no arguments
    onUpdateFn: null,
    // List of items in the cart
    cartItems: null,
    // Current display mode. Defaults to MIXED_VIEW
    displayMode: 0,
    // Currently running expand requests
    requests: [],
    // IDs being expanded right now
    expansions: [],
    // User-defined sections in the cart
    sections: [],
    // The custom download window assigned to this cart
    downloadWindow: null,

    /*
     * Initializes an instance of the Cart object with the default display mode and onUpdate function provided
     *
     * defaultDisplayMode - The default view the cart will display its items in - Optional, defaults to MIXED_VIEW
     * onUpdate - A function to call when the cart is updated - Optional
     */
    initialize: function(defaultDisplayMode, onUpdate) {
        // If we're given a function as an onUpdate (as we should)
        // store it to be called later.
        if (typeof onUpdate == "function")
            this.onUpdateFn = onUpdate;

        // If we aren't given a default, use "MIXED_VIEW"
        if ((typeof defaultDisplayMode == "undefined") || (defaultDisplayMode == null))
            defaultDisplayMode = Librarian.Cart.displayModes.MIXED_VIEW;

        // Set up the default view
        if (defaultDisplayMode == Librarian.Cart.displayModes.SLIDE_VIEW)
            this.displayMode = Librarian.Cart.displayModes.SLIDE_VIEW;
        else
            this.displayMode = Librarian.Cart.displayModes.MIXED_VIEW;

        // Initialize the item lists
        this.cartItems = new Librarian.Cart.List();
    },

    /*
     * Called when any change happens in the cart with updates not explicitly disabled
     *
     * save - Whether to save the cart to the server (if that setting is enabled) - Optional, defaults to true
     */
    onUpdate: function(save) {
        // If saving isn't explicitly refused and we normally save cart changes to the server,
        // send the save request to the server
        if ((save !== false) && Librarian.cart.saveCartToServer)
            Librarian.Cart.saveCart();

        // If the cart changed, close the CreatePackage window
        // Doing this forces the window to be re-opened so all download rules can be reprocessed
        if (this.downloadWindow) {
            this.downloadWindow.close();
            this.downloadWindow = null;
        }

        // If a custom onUpdate was set, run that as well
        if (typeof this.onUpdateFn == "function")
            this.onUpdateFn();

        // Update the cart buttons in the PageHeader
        if (Librarian.pageHeader != null)
            Librarian.pageHeader.updateCartButton();
    },

    //#region Get Methods

    /*
     * Gets the count of the current number of items in the cart, based on the options provided
     *
     * slideCount - Gets the count of all the items in the cart expanded down to the slide level - Optional, defaults to false
     * includeDeleted - Whether to include items that are unchecked in the cart - Optional, defaults to false
     * includeDuplicates - Whether to include items that are duplicated in the cart - Optional, defaults to the 'showDuplicates' setting value in Librarian.cart
     */
    getCount: function(slideCount, includeDeleted, includeDuplicates) {
        // If we aren't told Whether to do a slideCount, assume not.
        if ((typeof slideCount == "undefined") || (slideCount == null))
            slideCount = false;
        // If we aren't told Whether to include deleted items, assume not.
        if ((typeof includeDeleted == "undefined") || (includeDeleted == null))
            includeDeleted = false;
        // If we aren't told Whether to include duplicate items, assume not.
        if ((typeof includeDuplicates == "undefined") || (includeDuplicates == null))
            includeDuplicates = Librarian.cart.showDuplicates;

        var count = 0;
        // Count each non-deleted item inline
        // This is slightly faster than using the cartItems.getSize method with its various options
        for (var i = 0, length = this.cartItems.getSize(); i < length; i++) {
            var item = this.cartItems.items[i];

            // Skip deleted items
            if ((includeDeleted === false) && item.deleted)
                continue;

            // Get the count of each item if we are being asked for slide count
            if (slideCount)
                count += item.getCount(includeDeleted, includeDuplicates);
            else
                count++;
        }

        return count;
    },

    /*
     * Gets the list of items in the cart in a forced-file view
     * This forces any slide that is added to the cart to be added to a fake parent File object
     *
     * This is currently not used as it is very unintuitive - Showing a File object which isn't the full file confuses pretty much everyone
     *
     * includeDeleted - Whether to include items that are unchecked in the cart - Optional, defaults to false - Optional, defaults to false
     * includeDuplicates - Whether to include items that are duplicated in the cart - Optional, defaults to true
     */
    getCartFiles: function(includeDeleted, includeDuplicates) {
        return this.cartItems.getItems(includeDeleted, Librarian.Cart.addTypes.FILE, includeDuplicates);
    },

    /*
     * Gets the list of items in the cart in a forced-slide view.
     * This forces any group or file that is added to the cart to be expanded and show its individual slides
     *
     * includeDeleted - Whether to include items that are unchecked in the cart - Optional, defaults to false
     * includeDuplicates - Whether to include items that are duplicated in the cart - Optional, defaults to true
     */
    getCartSlides: function(includeDeleted, includeDuplicates) {
        return this.cartItems.getItems(includeDeleted, Librarian.Cart.addTypes.SLIDE, includeDuplicates);
    },

    /*
     * Gets the list of items in the cart in a view that shows exactly how they were added
     * Files added to the cart are shown as File objects, Groups as Group objects, Slides as Slide objects, etc
     *
     * includeDeleted - Whether to include items that are unchecked in the cart - Optional, defaults to false
     * includeDuplicates - Whether to include items that are duplicated in the cart - Optional, defaults to true
     */
    getCartItems: function(includeDeleted, includeDuplicates) {
        return this.cartItems.getItems(includeDeleted, null, includeDuplicates);
    },

    /*
     * Gets the list of items in the section as specified by the given index
     *
     * index - The index of the section for which to get the list of items
     * includeDeleted - Whether to include items that are unchecked in the cart - Optional, defaults to false
     * forceMixed - Whether to force the items in the section in to MIXED display mode - Optional, defaults to false
     * includeDuplicates - Whether to include items that are duplicated in the cart - Optional, defaults to true
     */
    getSectionItems: function(index, includeDeleted, forceMixed, includeDuplicates) {
        var items;
        // Only get mixed items if we're told to
        // This is used by CreatePackage to get what was added to the cart, exactly
        if (forceMixed === true)
            items = this.getCartItems(includeDeleted, includeDuplicates);
        else
            items = this.getDisplayItems(includeDeleted, includeDuplicates);

        var sectionItems = [];
        // Get every item whose set index matches the given index
        for (var i = 0; i < items.length; i++) {
            if (items[i].section == index)
                sectionItems.push(items[i]);
        }

        return sectionItems;
    },

    /*
     * Gets the list of slides in the section as specified by the given index
     *
     * index - The index of the section for which to get the list of items
     * includeDeleted - Whether to include items that are unchecked in the cart - Optional, defaults to false
     * includeDuplicates - Whether to include items that are duplicated in the cart - Optional, defaults to true
     */
    getSectionSlides: function (index, includeDeleted, includeDuplicates) {
        var items = this.getCartSlides(includeDeleted, includeDuplicates);

        var sectionItems = [];
        // Get every item whose set index matches the given index
        for (var i = 0; i < items.length; i++) {
            if (items[i].section == index)
                sectionItems.push(items[i]);
        }

        return sectionItems;
    },

    /*
     * Gets the list of sections in the cart with their list of items included
     *
     * includeDeleted - Whether to include items that are unchecked in the cart - Optional, defaults to false
     * includeDuplicates - Whether to include items that are duplicated in the cart - Optional, defaults to true
     */
    getSectionsList: function(includeDeleted, includeDuplicates) {
        var sectionList = [];
        for (var i = 0; i < this.sections.length; i++) {
            var section = Object.clone(this.sections[i]);
            section.items = this.getSectionItems(i, includeDeleted, includeDuplicates);
            sectionList.push(section);
        }

        return sectionList;
    },

    /*
     * Gets the list of items in the cart in the currently set display mode
     *
     * includeDeleted - Whether to include items that are unchecked in the cart - Optional, defaults to false
     * includeDuplicates - Whether to include items that are duplicated in the cart - Optional, defaults to true
     */
    getDisplayItems: function(includeDeleted, includeDuplicates) {
        // Return the current list of items based on how the cart is displaying.
        if (this.displayMode == Librarian.Cart.displayModes.SLIDE_VIEW)
            return this.getCartSlides(includeDeleted, includeDuplicates);
        else if (this.displayMode == Librarian.Cart.displayModes.MIXED_VIEW)
            return this.getCartItems(includeDeleted, includeDuplicates);
        else
            return this.getCartFiles(includeDeleted, includeDuplicates);
    },

    /*
     * Gets the data stored at the given index within the cart
     *
     * index - The location from which to get data
     */
    getItem: function(index) {
        return this.cartItems.getItem(index);
    },

    /*
     * Gets the cart item that represents the given data
     *
     * data - The data to find the representational cart item for
     * includeDeleted - Whether to include items that are unchecked in the cart - Optional, defaults to false
     * ignoreGroup - Whether to ignore the group properties of the data when finding the item or its parent - Optional, defaults to false
     */
    getItemFromData: function(data, includeDeleted, ignoreGroup) {
        var index = this.getItemIndex(data, includeDeleted, ignoreGroup);
        if (index < 0)
            return null;
        return this.getItem(index);
    },

    /*
     * Gets the index of the given item in the cart
     *
     * item - Item for which to find the current location within the cart
     * includeDeleted - Whether to include items that are unchecked in the cart - Optional, defaults to false
     * ignoreGroup - Whether to ignore the group properties of the data when finding the item or its parent - Optional, defaults to false
     */
    getItemIndex: function(item, includeDeleted, ignoreGroup) {
        return this.cartItems.indexOf(item, includeDeleted, ignoreGroup);
    },

    /*
     * Gets all items in the cart that are in the given Rule Group and are a trigger
     *
     * ruleGroup - ID of the Rule Group to which the found items should belong
     * includeDeleted - Whether to include items that are unchecked in the cart - Optional, defaults to false
     */
    getTriggerItems: function(ruleGroup, includeDeleted) {
        return this.getRuleItems(ruleGroup, "trigger", includeDeleted);
    },

    /*
     * Gets all items in the cart that are in the given Rule Group and are a dependent
     *
     * ruleGroup - ID of the Rule Group to which the found items should belong
     * includeDeleted - Whether to include items that are unchecked in the cart - Optional, defaults to false
     */
    getDependentItems: function(ruleGroup, includeDeleted) {
        return this.getRuleItems(ruleGroup, "dependent", includeDeleted);
    },

    /*
     * Gets all items in the cart that are in the given Rule Group and are an integrity item
     *
     * ruleGroup - ID of the Rule Group to which the found items should belong
     * includeDeleted - Whether to include items that are unchecked in the cart - Optional, defaults to false
     */
    getIntegrityItems: function(ruleGroup, includeDeleted) {
        return this.getRuleItems(ruleGroup, "integrity", includeDeleted);
    },

    /*
     * Gets all items in the cart that are in the given Rule Group and are a grouping item
     *
     * ruleGroup - ID of the Rule Group to which the found items should belong
     * includeDeleted - Whether to include items that are unchecked in the cart - Optional, defaults to false
     */
    getGroupingItems: function(ruleGroup, includeDeleted) {
        return this.getRuleItems(ruleGroup, "grouping", includeDeleted);
    },

    /*
     * Gets all items in the cart that are in the given Rule Group and are an ordering item
     *
     * ruleGroup - ID of the Rule Group to which the found items should belong
     * includeDeleted - Whether to include items that are unchecked in the cart - Optional, defaults to false
     */
    getOrderingItems: function(ruleGroup, includeDeleted) {
        return this.getRuleItems(ruleGroup, "ordering", includeDeleted);
    },

    /*
     * Gets all items in the cart that are in the given Rule Group and are a mandatory item
     *
     * ruleGroup - ID of the Rule Group to which the found items should belong
     * includeDeleted - Whether to include items that are unchecked in the cart - Optional, defaults to false
     */
    getMandatoryItems: function(ruleGroup, includeDeleted) {
        return this.getRuleItems(ruleGroup, "mandatory", includeDeleted);
    },

    /*
     * Gets all items in the cart that are in the given Rule Group and are an item of the given Rule type
     *
     * ruleGroup - ID of the Rule Group to which the found items should belong
     * ruleType - The type of Rule item that should be found
     * includeDeleted - Whether to include items that are unchecked in the cart - Optional, defaults to false
     */
    getRuleItems: function(ruleGroup, ruleType, includeDeleted) {
        return this.cartItems.filter(function(item) {
            return ((item.ruleGroup == ruleGroup) && item["is" + ruleType.toCapitalCase()] && ((includeDeleted === true) || !item.deleted));
        });
    },

    /*
     * Gets all items in the cart that are in the given Rule Group
     *
     * ruleGroup - ID of the Rule Group to which the found items should belong
     * includeDeleted - Whether to include items that are unchecked in the cart - Optional, defaults to false
     */
    getRuleGroupItems: function(ruleGroup, includeDeleted) {
        return this.cartItems.filter(function(item) {
            return ((item.ruleGroup == ruleGroup) && ((includeDeleted === true) || !item.deleted));
        });
    },

    /*
     * Gets all items in the cart with the given fixed position setting
     *
     * position - The fixed position setting value that should be found, if null then all fixed position items will be found
     * includeDeleted - Whether to include items that are unchecked in the cart - Optional, defaults to false
     */
    getPositionedItems: function(position, includeDeleted) {
        return this.cartItems.filter(function(item) {
            return ((!position && (item.cartPosition != null)) || (item.cartPosition == position)) && ((includeDeleted === true) || !item.deleted);
        });
    },

    //#endregion

    //#region Boolean Methods

    /*
     * Determines whether the data provided is able to be added to the cart
     *
     * data - Data to be added to the cart
     * notify - Whether to display the "Cart is Full" message when it is applicable - Optional, defaults to true
     */
    canAddToCart: function(data, notify) {
        if (!data)
            return false;

        // If InternalUseOnly is enabled and should prevent these items from going in the cart, check to make sure this item is not IUO
        if (!Librarian.contentRule.canAddToCart(data, null, null, null, null, data.parentfields)) {
            return false;
        }

        // If this is an invalid item, it's not allowed in the cart
        if (Librarian.Utils.isSourceNotAvailable(data))
            return false;

        // If the cart limit is disabled, we're done checking if the data can go in the cart
        if (Librarian.cart.maxItems <= 0)
            return true;

        // Check the cart count against the cart size limit
        var count = this.getCount(Librarian.cart.showSlideCount, true);
        count += (data.slideid > 0) ? 1 : (Librarian.cart.showSlideCount) ? (data.slidecount || 1) : 1;

        if (count <= Librarian.cart.maxItems)
            return true;

        // Only block adding to the cart when the setting is enabled
        if (Librarian.cart.blockAddWhenFull) {
            if (notify !== false)
                Librarian.Utils.error(Librarian.Lang.getString("cart_full"));
            return false;
        }
        // Otherwise, just notify the user
        else {
            if (notify !== false)
                Librarian.Utils.notification(Librarian.Lang.getString("cart_full_warning"));
            return true;
        }
    },

    /*
     * Determines whether the cart count is currently at or past the cart limit
     */
    isFull: function() {
        if (Librarian.cart.maxItems <= 0)
            return false;

        return this.getCount(Librarian.cart.showSlideCount, true) >= Librarian.cart.maxItems;
    },

    /*
     * Determines whether the given data is already in the cart
     *
     * data - Data to check for presence in the cart
     * includeDeleted - Whether to include items that are unchecked in the cart - Optional, defaults to false
     * includeDuplicates - Whether to include items that are duplicated in the cart - Optional, defaults to true
     * ignoreGroup - Whether to ignore the group properties of the data when finding the item or its parent - Optional, determines automatically based on file presence in groups
     */
    isInCart: function(data, includeDeleted, includeDuplicates, ignoreGroup, checkSubItems) {
        if (!data)
            return false;

        // If this is an invalid item, it's not allowed in the cart
        if (Librarian.Utils.isSourceNotAvailable(data))
            return false;

        var isPassworded = ((data.flags & Librarian.fileFlags.passwordProtected) == Librarian.fileFlags.passwordProtected),
            slideCount = data.slidecount;
        // Use the item count if it has one and we're not expanding groups
        if (!Librarian.tileList.expandGroupItemsToSlides && (data.itemcount > 0))
            slideCount = data.itemcount;

        // If this is a non-passworded file being checked and it has slides (IE, it's not a video)
        if (!isPassworded && (slideCount > 0) && (data.slidenumber <= 0)) {
            var slides = this.getCartSlides(includeDeleted),
                childCount = 0;

            // Check to see if all of its child slides are in the cart
            for (var i = slides.length; i--;) {
                if (slides[i].isChildOf(data))
                    childCount++;
            }

            // If they are, this file is in the cart
            if ((childCount > 0) && (childCount >= slideCount))
                return true;
        }

        // If ignoreGroup isn't provided, calculate it based on some complicated conditions
        if ((typeof ignoreGroup == "undefined") || (ignoreGroup == null)) {
            // If we have group rules enabled try to find if this item exists in the cart as part of a rule group
            // If it does, ignore the group information when checking if it's in the cart so that
            // the file and the group both show the items as checked
            if (Librarian.cart.enableGroupRules)
                ignoreGroup = this.doesItemHaveGroupRules(data);
            // If this is a file inside a group, don't add it to the parent group if there is one
            // Fixes a case where adding a file from inside a group would mark each subsequent file in the group as already in the cart
            else
                ignoreGroup = ((data.groupid > 0) || (data.presid > 0)) && (data.slideid <= 0) && (data.fileid > 0);
        }

        // Get the index of this item
        var index = this.cartItems.indexOf(data, includeDeleted, ignoreGroup);

        // If this item is in the cart, check if it is full
        if (index >= 0) {
            var item = this.cartItems.items[index];

            // If this item is a slide, this is it
            if (item.addType == Librarian.Cart.addTypes.SLIDE)
                return true;
            // If item is a file and the file is in the cart, this is it
            if (data.slideid <= 0 && item.slideid <= 0)
                return true;
            // Otherwise, if this item has every slide or it is password protected, it is marked as being in the cart
            else if ((item.slidecount == item.getSize(includeDeleted)) || isPassworded)
                return true;
        }

        // If we don't allow duplicates, check this item vs. every item and every item's children
        if (!Librarian.cart.allowDuplicates) {
            var items = this.getCartItems(includeDeleted);
            for (var i = items.length; i--;) {
                if (((!items[i].duplicate || (includeDuplicates !== false)) && items[i].equals(data, ignoreGroup)) || items[i].contains(data, null, ignoreGroup, includeDuplicates))
                    return true;
            }
        }

        // If it isn't, try to get the parent item.
        var parentItem = this.cartItems.getParentOrItemItself(data);

        // If there is a parent item
        if (parentItem) {
            // Check if it has this item as a child slide.
            // Only allow deleted if we are supposed to.
            return parentItem.contains(data, includeDeleted);
        }

        if (checkSubItems) {
            return this.checkSubItems(this.cartItems.items, data);
        }

        // If there isn't a parent, or it doesn't have this child,
        // it's obviously not in the cart.
        return false;
    },
    /*
    check if sub items, ex items inside a GF, are in cart 
    */
    checkSubItems: function(subItems, data) {
        var contains = false;
        for (var i = subItems.length; i--;) {
            if (subItems[i].contains(data, null, true))
                contains = true;
        }
        return contains;
    },

    /*
     * Determines whether the cart is currently in SLIDE display mode
     */
    isInSlideView: function() {
        return this.displayMode == Librarian.Cart.displayModes.SLIDE_VIEW;
    },

    /*
     * Determines whether the cart is currently in MIXED display mode
     */
    isInMixedView: function() {
        return this.displayMode == Librarian.Cart.displayModes.MIXED_VIEW;
    },

    /*
     * Determines whether the cart has an item in it with the given extension
     *
     * ext - The extension to search for in the cart
     * checkChildren - Whether to check the child items inside each cart item - Optional, defualts to false
     * includeDeleted - Whether to include items that are unchecked in the cart - Optional, defaults to true
     */
    hasItemWithExtension: function(ext, checkChildren, includeDeleted) {
        ext = (ext || '').trim().toLowerCase();
        if (ext.length == 0)
            return false;

        return this.hasItem(checkChildren, includeDeleted, function(item) {
            return Librarian.Utils.getExtensionFromData(item, true) == ext;
        });
    },

    /*
     * Determines whether the cart has a PowerPoint item in it
     *
     * checkChildren - Whether to check the child items inside each cart item - Optional, defualts to false
     * includeDeleted - Whether to include items that are unchecked in the cart - Optional, defaults to true
     */
    hasPowerPointItem: function(checkChildren, includeDeleted) {
        return this.hasItem(checkChildren, includeDeleted, function(item) {
            return Librarian.extensions.isPowerPointFile(Librarian.Utils.getExtensionFromData(item, true));
        });
    },

    /*
     * Determines whether the cart has an item within the given Cart Rules group
     *
     * cartItem - The cart item for which other items in the same Cart Rules group are being sought
     * includeDeleted - Whether to include items that are unchecked in the cart - Optional, defaults to true
     */
    hasRuleGroupItem: function(cartItem, includeDeleted) {
        return this.hasItem(false, includeDeleted, function(item) {
            return !item.equals(cartItem) && (item.ruleGroup == cartItem.ruleGroup);
        });
    },

    /*
     * Determines if the data given has a representation cart item that is in a Cart Rules group
     *
     * data - The data for which a the representational cart item will be founed and checked for the presence of a Cart Rules group
     */
    doesItemHaveGroupRules: function(data) {
        if (Librarian.cart.enableGroupRules) {
            var cartItem = this.getItemFromData(data, true, true);
            if (cartItem && (cartItem.ruleGroup > 0))
                return true;
        }
        return false;
    },

    /*
     * Determines whether the cart has an item in it that matches the given predicate
     *
     * checkChildren - Whether to check the child items inside each cart item - Optional, defualts to false
     * includeDeleted - Whether to include items that are unchecked in the cart - Optional, defaults to true
     * predicate - Boolean function which checks whether the given item matches a set of search criteria
     */
    hasItem: function(checkChildren, includeDeleted, predicate) {
        // If there is no predicate, nothing can match it
        if (typeof predicate != "function")
            return false;

        if ((typeof checkChildren == "undefined") || (checkChildren == null))
            checkChildren = false;
        if ((typeof includeDeleted == "undefined") || (includeDeleted == null))
            includeDeleted = true;

        return this.cartItems.some(function(item) {
            // Don't bother checking an item or its children if it's delted and eleted items are not allowed
            if ((includeDeleted === false) && item.deleted)
                return false;

            // Check this item or its children (if that option is enabled) against the given predicate
            return predicate(item) ||
                checkChildren && item.getItems(includeDeleted).some(function(child) {
                    return predicate(child);
                });
        });
    },

    /*
     * Determines whether the cart has any Slide items in it
     *
     * original - Whether to check the original Add Type vs. the current Add Type (This applies when an item is added as File and then split into Slides during a move operation)
     * predicate - Boolean function which checks whether the given item matches a set of search criteria - Optional and used in addition to the Slide type check
     * includeDeleted - Whether to include items that are unchecked in the cart - Optional, defaults to true
     */
    hasSlides: function(original, predicate, includeDeleted) {
        return this.hasItem(false, includeDeleted, function(item) {
            var type = item.addType;
            if ((original === true) && (item.originalAddType != null))
                type = item.originalAddType;
            return (type === Librarian.Cart.addTypes.SLIDE) && ((typeof predicate != "function") || predicate(item));
        });
    },

    /*
     * Determines whether the cart has any edited items in it
     *
     * includeDeleted - Whether to include items that are unchecked in the cart - Optional, defaults to true
     */
    hasEditedItems: function(includeDeleted) {
        return this.hasItem(false, includeDeleted, function(item) {
            // An "edited" item requires both edit XML and an edited thumbnail
            return ((typeof item.editsXML == "string") && (item.editsXML.length > 0) &&
                    (typeof item.editFileName == "string") && (item.editFileName.length > 0));
        });
    },

    /*
     * Determines whether the cart has any items in it with meta values that match the given name and value
     *
     * metaName - The name of the attribute to check the value of
     * value - The value of the attribute to check against
     * checkChildren - Whether to check the child items inside each cart item - Optional, defualts to false
     * includeDeleted - Whether to include items that are unchecked in the cart - Optional, defaults to true
     */
    hasItemWithMetaValue: function(metaName, value, checkChildren, includeDeleted) {
        var value = (value || '').trim().toLowerCase();
        return this.hasItem(checkChildren, includeDeleted, function(item) {
            var extraFields = item.extrafields;
            if (!extraFields || !extraFields[metaName])
                extraFields = item.parentfields;

            return extraFields && extraFields[metaName] && ((extraFields[metaName] || '').trim().toLowerCase() == value);
        });
    },

    //#endregion

    //#region Sections

    /*
     * Adds a new section to the list of sections in the cart
     *
     * name - Name of the new section to be added - Optional, defaults to a translateable value named 'section_defaultname'
     * description - Description of the new section to be added - Optional
     */
    addSection: function(name, description) {
        if ((typeof name == "undefined") || (name == null))
            name = Librarian.Lang.getString("section_defaultname");

        // If adding duplicate sections is disabled, return the duplicate section index
        if (!Librarian.cart.allowDuplicateSections) {
            var sectionIndex = -1;
            for (var i = 0, len = this.sections.length; i < len; i++) {
                if (this.sections[i].name == name) {
                    sectionIndex = i;
                    break;
                }
            }

            if (sectionIndex >= 0) {
                return sectionIndex;
            }
        }

        return this.sections.push({ name: name, description: description || ''}) - 1;
    },

    /*
     * Updates the name and description of the section represented by the given index
     *
     * index - The index of the section to update
     * name - Name to be set on the existing section - Optional, defaults to a translateable value named 'section_defaultname'
     * description - Description to be set on the existing section - Optional
     */
    updateSection: function(index, name, description) {
        if ((index < 0) || (index >= this.sections.length))
            return;

        if ((typeof name == "undefined") || (name == null))
            name = Librarian.Lang.getString("section_defaultname");

        this.sections[index] = { name: name, description: description };
    },

    /*
     * Removes a section by index
     *
     * index - The index of the section to remove
     * removeSlides - Whether to remove the section content - Optional, defaults to false
     */
    removeSection: function(index, removeSlides) {
        if ((index < 0) || (index >= this.sections.length))
            return;

        // Save the section so we can handle its slides
        var section = this.sections[index];
        // Remove it from the sections list
        this.sections.remove(index);

        // Find all items with section = index
        var items = this.getSectionItems(index, true);
        if (removeSlides == true) {
            // Remove each one from the cart
            for (var i = items.length; i--;)
                this.removeFromCart(items[i], false, false, true);
        }
        // If this is a valid section and there are other sections
        else if (section && (this.sections.length > 0)) {
            // Get the previous section and it's items
            var prevIndex = Math.max(0, index - 1);
            if (prevIndex != index) {
                // Reset the section for all the found items to prevIndex
                for (var i = items.length; i--;)
                    items[i].section = prevIndex;
            }
        }

        // Go through each remaining section and decrease their indeces by one
        // to fill the gap left by the section we just removed
        while (++index < (this.sections.length + 1)) {
            items = this.getSectionItems(index, true);
            var prevIndex = Math.max(0, index - 1);

            for (var i = items.length; i--;)
                items[i].section = prevIndex;
        }
    },

    /*
     * Swaps sections at the given indeces
     *
     * from - The index of the section being moved
     * to - The index of the destination of the section being moved
     */
    swapSections: function(from, to) {
        if ((from < 0) || (from >= this.sections.length))
            return false;
        if ((to < 0) || (to >= this.sections.length))
            return false;

        // Get the sections and their items
        var fromSection = Object.clone(this.sections[from]),
            fromItems = this.getSectionItems(from, true),
            toSection = Object.clone(this.sections[to]),
            toItems = this.getSectionItems(to, true);

        // Swap the sections
        this.sections[from] = toSection;
        this.sections[to] = fromSection;

        // Swap their items
        for (var i = fromItems.length; i--;)
            fromItems[i].section = to;
        for (var i = toItems.length; i--;)
            toItems[i].section = from;

        return true;
    },

    /*
     * Finds the index of a section in the cart by name
     *
     * name - The name of the section to find the index of
     */
    indexOfSection: function(name) {
        for (var i = 0; i < this.sections.length; i++) {
            if (this.sections[i].name == name)
                return i;
        }

        return -1;
    },

    /*
     * Sets the section number of the cart item represented by the given data
     *
     * data - The data whose representitive cart item's section number is being set
     * section - The index of the section to set on the data's cart item
     */
    setItemSection: function(data, section) {
        if (!data)
            return;

        var index = this.cartItems.indexOf(data);

        // If the item wasn't found, see if we have it's parent instead
        if (index < 0) {
            var parentItem = this.cartItems.getParentOrItemItself(data);
            // If we do, split the parent into its slides and get the index of the item
            if (parentItem) {
                this.cartItems.splitFileAndAddInPlace(parentItem);
                index = this.cartItems.indexOf(data);
            }
            else
                return;
        }

        // If we still don't have a valid index, stop trying
        if (index < 0)
            return;

        // Get the item and its children
        var item = this.cartItems.getItem(index),
            items = item.getItems(true);

        // Set the section on everything
        item.section = section;
        for (var i = items.length; i--;)
            items[i].section = section;
    },

    /*
     * Gets the index of the last section in the cart
     * Used when trying to automatically add things to the end of the cart
     */
    getLastSectionIndex: function() {
        return this.sections.length - 1;
    },

    //#endregion

    //#region Add/Remove

    /*
     * Adds the provided data to the cart
     *
     * data - Data to be added to the cart
     * fromCart - Whether the request to add this item is coming from within the cart. Controls whether the cart window's contents are updated automatically - Optional, defaults to false
     * update - Whether to run the update function after this operation is complete - Optional, defaults to true
     * section - The index of the section to add this new item to - Optional, defaults to 0
     * fromRules - Whether to bypass the "allowed" checks because this is from group rules - Optional, defaults to false
     * onComplete - Callback to call once the item has been added - Optional
     *
     * Returns whether the item was added to the cart successfully
     */
    addToCart: function(data, fromCart, update, section, fromRules, onComplete) {
        return this.addToCartEx(data, fromCart, update, section, fromRules, onComplete) != null;
    },

    /*
     * Adds the provided data to the cart
     *
     * data - Data to be added to the cart
     * fromCart - Whether the request to add this item is coming from within the cart. Controls whether the cart window's contents are updated automatically - Optional, defaults to false
     * update - Whether to run the update function after this operation is complete - Optional, defaults to true
     * section - The index of the section to add this new item to - Optional, defaults to 0
     * fromRules - Whether to bypass the "allowed" checks because this is from group rules - Optional, defaults to false
     * onComplete - Callback to call once the item has been added - Optional
     *
     * Returns the item that was added to the cart successfully or null if it wasn't
     */
    addToCartEx: function(data, fromCart, update, section, fromRules, onComplete) {
        if ((typeof fromRules == "undefined") || (fromRules == null))
            fromRules = false;

        // Don't allow this item to be added to the cart if it violates Librarian rules
        if (!fromRules && !Librarian.cart.canAddToCart(data))
            return null;

        // Don't allow more items to be added to the cart if it is full.
        if (!fromRules && !this.canAddToCart(data))
            return null;

        if ((typeof fromCart == "undefined") || (fromCart == null))
            fromCart = false;
        if ((typeof update == "undefined") || (update == null))
            update = true;
        // Default to the first section if we're not given another one
        if ((typeof section == "undefined") || (section == null))
            section = 0;

        var expand = false;
        // If this is an item, add it straight to the cart and expand
        if (((data.slidenumber == null) || (data.slidenumber <= 0)) && (Librarian.tileList.expandGroupItemsToSlides || (data.itemnumber == null))) {
            if (data.addType == null)
                data.addType = Librarian.Cart.addTypes.FILE;

            expand = (data.isslideshow !== true) && ((data.flags & Librarian.fileFlags.passwordProtected) != Librarian.fileFlags.passwordProtected);
        }
            // Otherwise mark this is a a slide if it doesn't have an addType already
        else if (data.addType == null)
            data.addType = Librarian.Cart.addTypes.SLIDE;

        // Make sure we reset the deleted flag so this can actually be added
        data.deleted = false;

        // Don't expand items added from group rules
        if (fromRules && !Librarian.cart.expandGroupRuleItems)
            expand = false;

        // Create an item out of the data
        var item = new Librarian.Cart.Item(data);
        // If this is a file or group, remove the slides that are already in the cart
        if (expand)
            this.cartItems.removeItemChildren(item);

        // Add this item to the section
        item.section = section;

        // If this is a file inside a group, don't add it to the parent group if there is one
        // Fixes a case where adding a file from inside a group would mark each subsequent file in the group as already in the cart
        var ignoreGroup = ((data.groupid > 0) || (data.presid > 0)) && (data.slideid <= 0) && (data.fileid > 0);

        // Add this item to the cart
        // The list's method automatically searches for a parent item
        this.cartItems.addItem(item, null, ignoreGroup);
        if (expand)
            this.expandItem(item, update);
        // Add rules to this item if it isn't from rules already
        if (!fromRules)
            this.addRules(item, null, onComplete, update);
        else if (typeof onComplete == "function")
            onComplete();

        // Only run these functions if we're supposed to be updating
        if (update) {
            // Fire onUpdate if it exists
            this.onUpdate(expand === false);

            Librarian.Cart.onChange();
        }

        // If we don't have a cart window already open, but we are supposed to open it when something is added, try to open the window
        if (Librarian.cart.openCartOnAdd && (!Librarian.cartWindow || !Librarian.cartWindow.isVisible()) && (typeof Library.openCartWindow == "function"))
            Library.openCartWindow();

        return item;
    },

    /*
     * Checks whether an item can be inserted before calling doInsertBefore which actually does the inserting
     *
     * data - Data to be added to the cart
     * targetData - Data that represents the item before which the given data will be inserted
     * onInsert - Callback which is called after the insert has completed - Optional
     */
    insertBefore: function(data, targetData, onInsert) {
        onInsert = onInsert || $empty;

        // If we're not given good data, stop
        if ((typeof data == "undefined") || (data == null) ||
            (typeof targetData == "undefined") || (targetData == null)) {
            onInsert(data, false);
            return;
        }

        // Don't allow this item to be added to the cart if it violates Librarian rules
        if (!Librarian.cart.canAddToCart(data)) {
            Librarian.Utils.error(Librarian.Lang.getString("cart_cantadd"));
            onInsert(data,  false);
            return;
        }

        // Don't allow more items to be added to the cart if it is full
        if (!this.canAddToCart(data)) {
            Librarian.Utils.error(Librarian.Lang.getString("cart_full"));
            onInsert(data,  false);
            return;
        }

        // Don't allow adding something that's already in there
        if (this.isInCart(data)) {
            onInsert(data,  false);
            return;
        }

        // Keep track of whether to use the parent index
        var parent = false;
        if (this.isInSlideView()) {
            // If the target was added as a file
            if (targetData.addType == Librarian.Cart.addTypes.FILE) {
                // And we're not dropping it on the first slide,
                // split it into its individual slides
                if (targetData.slidenumber > 1)
                    this.cartItems.splitFileAndAddInPlace(Librarian.Cart.Item.makeParent(targetData));
                // Otherwise, remember to get the parent index instead
                else
                    parent = true;
            }
        }

        var itemIndex;
        // Get the index of the parent, if we're told to
        if (parent)
            itemIndex = this.cartItems.indexOfParent(targetData, true);
        // Otherwise just get the index of this item
        else
            itemIndex = this.cartItems.indexOf(targetData, true);

        // Get the sizes of the current cart lists
        var itemSize = this.cartItems.getSize();

        // If the calculated index is -1, just add it to the end
        if (itemIndex < 0)
            itemIndex = itemSize;

        // Create a cart item from the parent data
        var item = new Librarian.Cart.Item(data),
            // Whether to expand an item
            expand = false;

        // Put this item in the same section that the target had
        item.section = targetData.section;

        // If this is a file, mark it as a file and expand
        if (isNaN(item.slideid) || (item.slideid <= 0)) {
            if (item.addType == null)
                item.setAddType(Librarian.Cart.addTypes.FILE);
            expand = true;
        }
        // Otherwise mark this is a a slide if it doesn't have an addType already
        else if (item.addType == null)
            item.setAddType(Librarian.Cart.addTypes.SLIDE);

        this.addRules(item, true, this.doInsertBefore.pass([item, itemIndex, expand, onInsert]));
    },

    /*
     * Inserts the given data before the item represented by the given `targetData`
     *
     * item - Data to be added to the cart
     * itemIndex - Location that the given data will be inserted to
     * expand - Whether or not to expand the inserted item to its slides
     * onInsert - Callback which is called after the insert has completed - Optional
     */
    doInsertBefore: function(item, itemIndex, expand,  onInsert) {
        onInsert = onInsert || $empty;

        // If we're not given good data, stop
        if ((typeof item == "undefined") || (item == null)) {
            onInsert(item, false);
            return;
        }

        // Make sure this item can be inserted here
        if (Librarian.cart.enableGroupRules && !item.canInsert(itemIndex)) {
            onInsert(item, false);
            return;
        }

        this.cartItems.insertItemAt(item, itemIndex);
        if (expand)
            this.expandItem(item);

        // Call the post-rules check
        if (Librarian.cart.enableGroupRules)
            item.onInsert();

        // Fire onUpdate
        this.onUpdate();

        Librarian.Cart.onChange();

        onInsert(item);
    },

    /*
     * Checks whether an item can be removed before calling doRemoveFromCart which actually does the removing
     *
     * data - The data to be removed from the cart
     * fromCart - Whether this request is coming from within the cart itself. If true, the item is marked as deleted, otherwise the item is removed - Optional, defaults to false
     * ignoreGroup - Whether to ignore the group properties of the data when finding the item to remove from the cart - Optional, defaults to false
     * update - Whether to run the update function after this operation is complete - Optional, defaults to true
     * fromRules - Whether to bypass the "allowed" checks because this is from group rules - Optional, defaults to false
     * onRemove - Callback which is called after the remove has completed - Optional
     * onRemoveFail - Callback which is called if remove failed - Optional
     */
    removeFromCart: function(data, fromCart, ignoreGroup, update, fromRules, onRemove, onRemoveFail) {
        // If we aren't told to ignore groups, assume not
        if ((typeof ignoreGroup == "undefined") || (ignoreGroup == null)) {
            if (Librarian.cart.enableGroupRules)
                ignoreGroup = this.doesItemHaveGroupRules(data);
            else
                ignoreGroup = false;
        }
        if ((typeof fromRules == "undefined") || (fromRules == null))
            fromRules = false;

        // Make sure this item can be removed first
        if (Librarian.cart.enableGroupRules) {
            var cartItem = this.cartItems.getParentOrItemItself(data, ignoreGroup);
            if (cartItem != null) {
                cartItem.canRemove(fromCart, ignoreGroup, update, fromRules, onRemove, onRemoveFail);
                return;
            }
        }

        this.doRemoveFromCart(data, fromCart, ignoreGroup, update, fromRules, onRemove);
    },

    /*
     * Removes the item that represents the given data from the cart or marks it as deleted
     *
     * data - The data to be removed from the cart
     * fromCart - Whether this request is coming from within the cart itself. If true, the item is marked as deleted, otherwise the item is removed - Optional, defaults to false
     * ignoreGroup - Whether to ignore the group properties of the data when finding the item to remove from the cart - Optional, defaults to false
     * update - Whether to run the update function after this operation is complete - Optional, defaults to true
     * fromRules - Whether to bypass the "allowed" checks because this is from group rules - Optional, defaults to false
     * onRemove - Callback which is called after the remove has completed - Optional
     * removeAutomaticallyAddedItemsOnly - Used by the post remove rules to determine whether or not to only remove items that were added automatically
     */
    doRemoveFromCart: function(data, fromCart, ignoreGroup, update, fromRules, onRemove, removeAutomaticallyAddedItemsOnly) {
        if (!data)
            return;

        var cartItem = this.cartItems.getParentOrItemItself(data, ignoreGroup);
        // If we aren't told to ignore groups, assume not
        if ((typeof ignoreGroup == "undefined") || (ignoreGroup == null))
            ignoreGroup = false;
        if ((typeof fromRules == "undefined") || (fromRules == null))
            fromRules = false;
        // If we aren't told this is happening from within the cart, assume not
        if ((typeof fromCart == "undefined") || (fromCart == null))
            fromCart = false;
        // If we aren't told to update, assume yes
        if ((typeof update == "undefined") || (update == null))
            update = true;

        // If this is from within the cart, just set the item deleted for now, don't actually remove it
        if (fromCart)
            this.cartItems.setItemDeleted(data);
        else {
            // If we're not in the cart, actually remove the items.
            this.cartItems.removeItemChildren(data, ignoreGroup);
            this.cartItems.removeItem(data, ignoreGroup);

            // Get this item's parent
            var parentItem = this.cartItems.getParentOrItemItself(data);

            // Make sure it isn't itself
            // and then remove this child from the parent
            if (parentItem && !parentItem.equals(data, ignoreGroup)) {
                parentItem.removeItemChildren(data, ignoreGroup);
                parentItem.removeItem(data, ignoreGroup);

                // If this parent is empty, get rid of it.
                if (parentItem.getSize(false) == 0)
                    this.cartItems.removeItem(parentItem);
            }

            // If we don't allow duplicates, go through and unset the duplicate slides if they aren't duplicate anymore
            if (!Librarian.cart.allowDuplicates)
                this.cartItems.updateDuplicateState();
        }

        // Run the post-rules checks
        if (!fromRules) {
            if (cartItem != null)
                cartItem.onRemove(fromCart, removeAutomaticallyAddedItemsOnly);
        }
        if (typeof onRemove == "function")
            onRemove(cartItem);

        // Fire onUpdate
        if (update) {
            this.onUpdate();

            // Update the checkboxes on the main page
            Librarian.Utils.updateAllCheckboxes();
        }
    },

    /*
     * Removes all items marked as deleted from the cart
     */
    removeAllDeleted: function() {
        var item;

        // For every item in the cart
        for (var i = 0; i < this.cartItems.items.length; i++) {
            item = this.cartItems.items[i];

            // If this is a file inside a group, don't add it to the parent group if there is one
            // Fixes a case where adding a file from inside a group would mark each subsequent file in the group as already in the cart
            var fileInGroup = ((item.groupid > 0) || (item.presid > 0)) && (item.slideid <= 0) && (item.fileid > 0);


            if(Librarian.features.fastlane.load === true && Librarian.FastLane.isEnabled) {
            
                if (item.deleted) {
                    // Set fromRules = true to bypass the post-rules checks
                    this.doRemoveFromCart(item, null, null, null, true);
                    i--;
                }

            } else {
            
                // If it's deleted or it's a file that is empty, remove it
                // Add a special check for files pretending to have slides and slideshows, because they are always "empty"
                if (item.deleted || ((item.slidenumber <= 0) && !item.isslideshow && !Librarian.extensions.hasFakeSlides(Librarian.Utils.getExtensionFromData(item, true)) && (item.getSize(false, true) == 0) && !fileInGroup && !item.fromRules)) {
                    // Set fromRules = true to bypass the post-rules checks
                    this.doRemoveFromCart(item, null, null, null, true);
                    i--;
                }

            }

            
        }

        // If we don't allow duplicates, go through and unset the duplicate slides if they aren't duplicate anymore
        if (!Librarian.cart.allowDuplicates)
            this.cartItems.updateDuplicateState();

        // Update the checkboxes on the main page
        Librarian.Utils.updateAllCheckboxes();
    },

    //#endregion

    //#region Expand

    /*
     * Loads information about content rules from the server and stores it in this item
     *
     * item - The cart item for which content rules are being retrieved from the server
     * insert - Whether or not this is an insert operation - Optional, defaults to false
     * onComplete - Callback to call once rules have been loaded - Optional
     * update - Whether or not to run the update rules after completing this operation - Optional
     */
    addRules: function(item, insert, onComplete, update) {
        var onRulesLoaded = function(cartItem) {
            // If this isn't an insert then call the normal onAdd callback
            // Inserts need the rule data before they can be processed so the callback below will be used to check those
            if (cartItem && (insert !== true) && (typeof cartItem.onAdd == "function"))
                cartItem.onAdd(null, update);

            if (typeof onComplete == "function")
                onComplete();
        };

        // If this already has rules, don't bother loading more
        if (item.ruleGroup > 0) {
            onRulesLoaded(item);
            return;
        }

        var request = Librarian.Cart.getItemRules(item, insert, onRulesLoaded);
        if (request != null)
            this.requests.push(request);
    },

    /*
     * Expands the given cart item into its smallest components
     *
     * item - The cart item to expand
     * update - Whether to run the onUpdate function after this operation completes
     */
    expandItem: function(item, update) {
        // Expand this item to its slides
        // Files and groups are handled differently
        if (item.presid > 0) {
            // Make sure this presentation isn't already expanding
            if (!this.expansions.contains('P' + item.presid))
                this.expandVirtualToSlides(item, update);
        }
        else if (item.groupid > 0) {
            // Make sure this group isn't already expanding
            if (!this.expansions.contains('G' + item.groupid))
                this.expandGroupToSlides(item, update);
        }
        else {
            // Make sure this file isn't already expanding
            if (!this.expansions.contains('F' + item.fileid))
                this.expandFileToSlides(item, update);
        }
    },

    /*
     * Expands a file item in the cart to slides
     *
     * parentItem - The file being expanded to slides
     * update - Whether to run the onUpdate function after this operation completes
     */
    expandFileToSlides: function(parentItem, update) {
        // Add this file to the list of currently expanding items
        this.expansions.push('F' + parentItem.fileid);
        // Build the URL used to fetch group data for this virtual
        var url = Librarian.path.getMethodUrl("getslides") + "&fid=" + parentItem.fileid + "&out=dgrid";

        if (Librarian.search.viewNameByType && Librarian.search.viewNameByType[Librarian.Search.outputTypes.SLIDES])
            url += "&vname=" + Librarian.search.viewNameByType[Librarian.Search.outputTypes.SLIDES];

        this.expandToSlides(url, parentItem, update);
    },

    /*
     * Expands a virtual presentation item in the cart to slides
     *
     * parentItem - The virtual presentation being expanded to slides
     * update - Whether to run the onUpdate function after this operation completes
     */
    expandVirtualToSlides: function(parentItem, update) {
        // Add this presentation to the list of currently expanding items
        this.expansions.push('P' + parentItem.presid);
        // Build the URL used to fetch group data for this virtual
        var url = Librarian.path.getMethodUrl("getvp") + "&pid=" + parentItem.presid + "&comp=1&out=dgrid&expand=" + (Librarian.tileList.expandGroupItemsToSlides ? '1' : '0');

        if (Librarian.search.viewNameByType && Librarian.search.viewNameByType[Librarian.Search.outputTypes.SLIDES])
            url += "&vname=" + Librarian.search.viewNameByType[Librarian.Search.outputTypes.SLIDES];

        this.expandToSlides(url, parentItem, update);
    },

    /*
     * Expands a group item in the cart to slides
     *
     * parentItem - The group being expanded to slides
     * update - Whether to run the onUpdate function after this operation completes
     */
    expandGroupToSlides: function(parentItem, update) {
        // Add this group to the list of currently expanding items
        this.expansions.push('G' + parentItem.groupid);
        // Build the URL used to fetch group data for this group
        var url = Librarian.path.getMethodUrl("getgslides") + "&gid=" + parentItem.groupid + "&out=dgrid&expand=" + (Librarian.tileList.expandGroupItemsToSlides ? '1' : '0');

        if (Librarian.search.viewNameByType && Librarian.search.viewNameByType[Librarian.Search.outputTypes.SLIDES])
            url += "&vname=" + Librarian.search.viewNameByType[Librarian.Search.outputTypes.SLIDES];

        if (Librarian.search.viewNameByType && Librarian.search.viewNameByType[Librarian.Search.outputTypes.FILES])
            url += "&fvname=" + Librarian.search.viewNameByType[Librarian.Search.outputTypes.FILES];

        this.expandToSlides(url, parentItem, update);
    },

    /*
     * Expands a given item to slides using the provided API URL
     *
     * url - The URL to the API being used to expand this item
     * parentItem - The item being expanded
     * update - Whether to run the onUpdate function after this operation completes
     */
    expandToSlides: function(url, parentItem, update) {
        var self = this,
            request = new Librarian.Request.JSON({
                url: url,
                onSuccess: function(json) {
                    // Pass the parentItem and update flag to the handler
                    self.expandLoadComplete(json, parentItem, update, this.index);
                },
                onFailure: Librarian.Utils.onFailure
            });

        // Store the request
        var index = this.requests.push(request) - 1;
        // and the request's index
        this.requests[index].index = index;

        // Send the request to be processed
        this.requests[index].send();
    },

    /*
     * Processes the data loaded from the server during expansion of a cart item
     *
     * json - The expanded data from the server
     * parentItem - The item being expanded
     * update - Whether to run the onUpdate function after this operation completes
     * index - The index of the request that just completed
     */
    expandLoadComplete: function(json, parentItem, update, index) {
        this.clearRequest(index);

        // Remove this item from the expanding list now that it's done
        if (parentItem.presid > 0)
            this.expansions.remove(this.expansions.indexOf('P' + parentItem.presid));
        else if (parentItem.groupid > 0)
            this.expansions.remove(this.expansions.indexOf('G' + parentItem.groupid));
        else
            this.expansions.remove(this.expansions.indexOf('F' + parentItem.fileid));

        // If we didn't get a valid response, don't continue.
        if (!json || !json.data || !json.data.length)
            return;

        var items;
        // File / Global Favorite
        if (json.data[0].slides)
            items = json.data[0].slides;
        // Virtual Presentation
        else if (json.data[0].items)
            items = json.data[0].items;
        // Error
        else
            return;

        // If there are no items in this file, check if it's one of those files that pretends to have slides
        if (items.length == 0) {
            var ext = Librarian.Utils.getExtensionFromData(parentItem);

            // If it is, turn the parent item into a "child" and add that to the list
            if (Librarian.extensions.hasFakeSlides(ext)) {
                var childItem = Object.clone(parentItem);
                childItem.slidenumber = 1;
                items.push(childItem);
            }
        }

        var item,
            duplicates = false;
        // Create a new item for every slide in this group
        for (var i = 0; i < items.length; i++) {
            // If this is a presentation with a -1 slide id and an invalid file type,
            // the source isn't available and we should not add it to the cart
            if (Librarian.Utils.isSourceNotAvailable(items[i]))
                continue;

            item = new Librarian.Cart.Item(items[i]);
            // Save the slide count as the number of items we have here
            item.slidecount = items.length;
            // Save the extrafields from the parent
            item.setParentFields(parentItem.extrafields);
            // If the parent item has file flags, save those as well
            if (parentItem.flags > item.flags)
                item.flags = parentItem.flags;
            item.setAddType(Librarian.Cart.addTypes.FILE);

            // The children fetched from the server don't have all the information
            // from their parent group, so assign it here instead.
            if (parentItem.presid > 0) {
                if (Librarian.cart.showMyFavoriteName)
                    item.name = parentItem.name;
            }
            else if (parentItem.groupid > 0) {
                if (Librarian.cart.showGlobalFavoriteName)
                    item.name = parentItem.name;
            }
            else
                item.name = parentItem.name;

            // If this is the member of a group...
            if ((parentItem.presid > 0) || (parentItem.groupid > 0)) {
                var parentext = Librarian.Utils.getExtensionFromData(parentItem),
                    ext = Librarian.Utils.getExtensionFromData(item);

                // Set the child's extension to the extension of the group,
                // but also save the source file extension
                if (ext != parentext) {
                    item.sourceext = ext;
                    item.ext = parentext;
                }
            }
            item.groupid = parentItem.groupid;
            item.presid = parentItem.presid;
            item.section = parentItem.section;

            // Group rules
            item.isDependent = parentItem.isDependent;
            item.isTrigger = parentItem.isTrigger;
            item.isIntegrity = parentItem.isIntegrity;
            item.isOrdering = parentItem.isOrdering;
            item.isGrouping = parentItem.isGrouping;
            item.ruleGroup = parentItem.ruleGroup;
            item.orderindex = parentItem.orderindex;
            item.fromRules = parentItem.fromRules;
            item.rules = parentItem.rules;

            // If we've expanded a group to its slides, make sure the item number is correct for display
            if ((item.groupid > 0) || (item.presid > 0))
                item.itemnumber = i + 1;

            // Mark duplicates added to the cart as such
            if (!Librarian.cart.allowDuplicates && Librarian.userCart && Librarian.userCart.isInCart(item, true)) {
                item.duplicate = true;
                duplicates = true;
            }

            // If this slide isn't in the parent's "items" list, add it
            // Use "push" instead of "addItem" because at this point we just want to add each "item" to its parent, nothing else
            if (!parentItem.contains(item, null, true))
                parentItem.items.push(item);
        }

        if (Librarian.userCart) {
            // If this parent doesn't have any items, why keep it in the cart?
            if (parentItem.getSize() == 0)
                Librarian.userCart.removeFromCart(parentItem, false, false, false);
        }

        // Wait until all the expansions are done before we run the updates
        if (this.expansions.length == 0) {
            // Fire onUpdate
            if (update !== false)
                this.onUpdate();

            if (duplicates)
                Librarian.Utils.notification(Librarian.Lang.getString("cart_duplicate"));

            Librarian.Cart.onChange();

            // Update the checkboxes on the main page
            Librarian.Utils.updateAllCheckboxes();
        }
    },

    //#endregion

    //#region Helper Methods

    /*
     * Clears all content and pending requests from the cart
     */
    clear: function() {
        // Remove the items
        this.cartItems.clear();

        // Stop each request
        for (var i = 0; i < this.requests.length; i++)
            this.clearRequest(i);

        // Remove each section
        for (var i = 0; i < this.sections.length; i++) {
            if (this.sections[i])
                this.sections[i] = null;
        }

        // Truncate the lists
        this.requests.length = 0;
        this.expansions.length = 0;
        this.sections.length = 0;

        // Fire onUpdate
        this.onUpdate();
    },

    /*
     * Cancels the request represented by the given index within the list of pending requests
     *
     * index - The index which represents the request to be cancelled
     */
    clearRequest: function(index) {
        if (this.requests[index]) {
            this.requests[index].cancel();
            this.requests[index] = null;
        }
    },

    /*
     * Changes the view of the cart to the given view mode
     * Disables the navigation buttons for preview windows also due to an issue with them not behaving correctly after the cart view is changed
     *
     * view - View type to change the cart to
     */
    changeView: function(view) {
        // Make sure the view we are changing to is valid.
        if ((view >= Librarian.Cart.displayModes.MIXED_VIEW) &&
            (view <= Librarian.Cart.displayModes.SLIDE_VIEW)) {
            this.displayMode = view;
            // Force an update to make sure we're
            // displaying the most up-to-date information.
            Librarian.Cart.onChange();

            // Disable the nav buttons for all existing preview windows
            // so that the "next/previous" item buttons don't screw up
            if (previewWindows) {
                for (var i = 0; i < previewWindows.length; i++)
                    previewWindows[i].disableNavButtons();
            }
        }
    },

    /*
     * Moves an item in the cart from one location to another
     *
     * firstItem - The item to be moved
     * secondItem - The item in front of which the first item will be moved
     * update - Whether to run the update function after this operation is complete - Optional, defaults to false
     * fromRules - Whether to bypass the "allowed" checks because this is from group rules - Optional, defaults to false
     */
    moveItem: function(firstItem, secondItem, update, fromRules) {
        if ((typeof update == "undefined") || (update == null))
            update = false;
        if ((typeof fromRules == "undefined") || (fromRules == null))
            fromRules = false;

        // Make sure this item can be moved first
        var oldLoc = -1;
        if (!fromRules && Librarian.cart.enableGroupRules && firstItem) {
            oldLoc = this.getItemIndex(firstItem);
            if ((typeof firstItem.canMove == "function") && !firstItem.canMove(secondItem))
                return;
        }

        this.cartItems.moveItem(firstItem, secondItem, fromRules);

        // always fire onUpdate if fastlane is enabled
        if (update !== false || (Librarian.features.fastlane.load && Librarian.FastLane.isEnabled) ) {
            // Fire onUpdate if it exists
            this.onUpdate();

            Librarian.Cart.onChange();
        }

        // Run the post-rules checks
        if (!fromRules && (typeof firstItem.onMove == "function"))
            firstItem.onMove(oldLoc);
    },

    /*
     * Prints the cart rules for each item in the cart to help with debugging any rules issues
     */
    printRulesDebug: function() {
        if (!window.console)
            return;

        for (var i = 0, length = this.cartItems.items.length; i < length; i++) {
            var cartItem = this.cartItems.items[i];
            console.log("Cart Index: " + i);
            console.log(" Order Index: " + cartItem.orderindex);
            console.log(" isGrouping:   " + cartItem.isGrouping);
            console.log(" isOrdering:   " + cartItem.isOrdering);
            console.log(" isIntegrity:  " + cartItem.isIntegrity);
            console.log(" isTrigger:    " + cartItem.isTrigger);
            console.log(" isDependent:  " + cartItem.isDependent);
            console.log(" isMandatory:  " + cartItem.isMandatory);
            console.log(" cartPosition: " + cartItem.cartPosition);
            console.log(cartItem);
        }
    }

    //#endregion
});

Librarian.Cart.extend({
    // MIXED_VIEW     - Display items as they were added to the cart, files as files and slides as slides
    // SLIDE_VIEW     - Display each item as a list of its child slides.
    displayModes: {
        MIXED_VIEW: 0,
        SLIDE_VIEW: 1
    },

    addTypes: {
        FILE: 0,
        SLIDE: 1,
        CATEGORY: 2
    },

    //#region Open/Close Window

    /*
     * Opens the cart window
     *
     * onVPCreatedFn - A function run when a My Favorite is created
     * onVPCatCreatedFn - A function run when a My Favorite category is created
     */
    openCart: function(onVPCreatedFn, onVPCatCreatedFn) {
        if (!mainPanel || !mainPanel.loaded)
            return false;

        // If the cart window doesn't exist or it's hidden, create a new one
        if (!Librarian.cartWindow || !Librarian.cartWindow.isVisible()) {
            Librarian.cartWindow = new Librarian.Cart.Window({}, onVPCreatedFn, onVPCatCreatedFn);
            Librarian.cartWindow.show();
        }
        // If it's just minimized, show it
        else if (Librarian.cartWindow.isMinimized)
            Librarian.cartWindow.restore();

        return false;
    },

    /*
     * Closes the cart window
     */
    closeCart: function() {
        if (Librarian.cartWindow) {
            Librarian.cartWindow.close();
            Librarian.cartWindow = null;
        }
    },

    /*
     * Opens the cart window to a particular function such as "create" or "save"
     *
     * method - The method to open once the cart window opens
     * param1 - The first parameter for the specified function - Optional
     * param2 - The second parameter for the specified function - Optional
     * param3 - The third parameter for the specified function - Optional
     * param4 - The fourth parameter for the specified function - Optional
     * param5 - The fifth parameter for the specified function - Optional
     *
     * Returns false
     */
    openCartFunction: function(method, param1, param2, param3, param4, param5) {
        if (!mainPanel || !mainPanel.loaded)
            return false;

        // If the cart window hasn't been created,
        // create one and then immediately close it
        // so the it doesn't get in the user's way
        if (!Librarian.cartWindow) {
            Librarian.cartWindow = new Librarian.Cart.Window({}, method == "save" ? param1 : null, method == "save" ? param2 : null);
            Librarian.cartWindow.close();
        }

        if (method == "create")
            Librarian.cartWindow.downloadCart(null, param1, param2);
        else if (method == "save")
            Librarian.cartWindow.saveAsFavorite(param1, param2, param3, param4, param5);
        else if (method == "send")
            Librarian.Cart.sendCart();

        return false;
    },

    //#endregion

    //#region Clear

    /*
     * Clears the cart after prompting the user
     *
     * onClear - Function to run after the user has accepted the clear prompt
     *
     * Returns false
     */
    clearCart: function(onClear) {
        // If there is no cart or the cart is empty, there is nothing to clear.
        if (!Librarian.userCart || ((Librarian.userCart.sections.length == 0) && (Librarian.userCart.cartItems.getSize() == 0)))
            return false;

        // Make sure the user wants to do this first
        var confirm = new Librarian.ConfirmWindow({
            id: "clearCartConfirmWindow",
            title: Librarian.Lang.getString("cart_clear"),
            question: Librarian.Lang.getString("cart_clear?")
        });
        confirm.onFirstButtonClicked = Librarian.Cart.doClear;
        confirm.show();

        return false;
    },

    /*
     * Performs the clear operation on the cart
     *
     * notify - Whether to notify the user that the cart has been cleared - Optional, defaults to true
     */
    doClear: function(notify) {
        // If we aren't told Whether to notify, assume yes.
        if ((typeof notify == "undefined") || (notify == null))
            notify = true;
        // If there is no cart or the cart is empty, there is nothing to clear.
        if (!Librarian.userCart || ((Librarian.userCart.sections.length == 0) && (Librarian.userCart.getCount(false, true) == 0)))
            return;

        // Clear the entire cart
        Librarian.userCart.clear();

        // Tell the user
        if (notify && !(Librarian.features.fastlane.load && Librarian.FastLane.isEnabled)) {
            Librarian.Utils.notification(Librarian.Lang.getString("cart_cleared"));
        }

        // Update the checkboxes on the main page
        Librarian.Utils.updateAllCheckboxes();

        Librarian.Cart.onChange();

        if (Librarian.cartWindow)
            Librarian.cartWindow.textReplaces = null;
    },

    //#endregion

    //#region Send

    /*
     * Sends the cart content as a portal. If the cart contains sections, this will automatically save the cart as a My Favorite and the send that instead
     *
     * eventType - The type of event to send this content with. Special restrictions are in place for newsletters - Optional
     */
    sendCart: function(eventType) {
        // If there is no cart or the cart is empty, there is nothing to clear.
        if (!Librarian.userCart || (Librarian.userCart.cartItems.getSize() == 0))
            return false;

        if (typeof eventType != "number")
            eventType = Librarian.eventType.oneOff;

        var openSendWindow = function(data) {
            new Librarian.EventSendWindow({
                eventType: eventType,
                onSuccess: function() {
                    if (Librarian.cart.clearCartOnSend)
                        Librarian.Cart.doClear();
                }.bind(this)
            }, data).show();
        };

        if (Librarian.cart.canCombineShares &&
            (Librarian.userCart.sections.length > 0 || Librarian.userCart.hasEditedItems())) {
            // Newsletters are not allowed to send edited items
            if (eventType === Librarian.eventType.newsletter) {
                Librarian.Utils.notification(Librarian.Lang.getString("cart_newsletter_noedits"), false);
                return false;
            }

            // Create a pre-named My Favorite in a hidden category and send that
            var createPackage = new Librarian.CreatePackage({
                showNotification: false,
                onSuccess: function(json) {
                    var data = (json && json.data && json.data[0]);
                    if (!data)
                        return;

                    // Set ext so we can tell the content type
                    data.ext = "vpres";

                    openSendWindow(data);
                }
            });
            createPackage.send({ clearOnSave: false }, { catid: -2, name: "Content Collection " + new Date().format("%m-%d-%Y %k.%M.%S"), description: '', create: false });
        }
        else {
            // Newsletters are not allowed to send slides
            if ((eventType === Librarian.eventType.newsletter) && Librarian.userCart.hasSlides()) {
                Librarian.Utils.notification(Librarian.Lang.getString("cart_newsletter_noslides"), false);
                return false;
            }

            openSendWindow(Librarian.userCart.getCartItems());
        }

        return false;
    },

    /*
     * Determines whether sending from the cart is allowed
     */
    canSend: function() {
        return Librarian.event.canShare;
    },

    /*
     * Determines whether all of the items in the cart can be sent
     */
    canSendItems: function() {
        var items = Librarian.userCart.getCartItems();
        for (var i = items.length; i--;) {
            var item = items[i];

            if (!Librarian.Cart.canSendItem(item))
                return false;
        }

        return true;
    },

    /*
     * Determines whether an individual item can be sent
     */
    canSendItem: function(item) {
        return Library.canShare(item);
    },

    //#endregion

    //#region Save/Load from Server

    /*
     * Saves the content of the cart to the server
     */
    saveCart: function() {
        if (!Librarian.userCart || !Librarian.cart.saveCartToServer)
            return;

        // Get all items, including deleted
        var cartList = Librarian.userCart.getCartItems(true);
        if (!cartList)
            return;

        var request = new Librarian.Request({
            method: "post",
            url: Librarian.path.getUpdateUrl("savecart"),
            data: {
                fcont: JSON.encode(cartList)
            }
        });
        request.send();

        request = null;
    },

    /*
     * Loads a previously saved copy of the cart from the server
     */
    loadCart: function() {
        function onLoadCart(json) {
            if (!Librarian.userCart || !json)
                return;

            // Add each item to the cart
            for (var i = 0; i < json.length; i++)
                Librarian.userCart.addToCart(json[i], false);

            // Update the checkboxes on the main page
            Librarian.Utils.updateAllCheckboxes();

            Librarian.Cart.onChange();

            // Run the update function to make sure all the counts are displayed correctly
            Librarian.userCart.onUpdate(false);
        }

        var request = new Librarian.Request.JSON({
            url: Librarian.path.getMethodUrl("getcart") + "&out=text",
            onSuccess: onLoadCart
        });
        request.send();

        request = null;
    },

    //#endregion

    /*
     * Updates the cart window after changes are made
     */
    onChange: function() {
        if (Librarian.cartWindow) {
            if (Librarian.cartWindow.isVisible())
                Librarian.cartWindow.reload();

            Librarian.cartWindow.updateCreateWindow();
        }
    },

    /*
     * Loads information about content rules from the server and stores it in this item
     *
     * item - The cart item for which content rules are being retrieved from the server
     * insert - Whether or not this is an insert operation - Optional, defaults to false
     * onComplete - Callback to call once rules have been loaded - Optional
     * update - Whether or not to run the update rules after completing this operation - Optional
     */
    getItemRules: function(item, insert, onComplete) {
        onComplete = onComplete || $empty;
        if (!Librarian.cart.enableGroupRules) {
            onComplete(item);
            return null;
        }

        var contentType = Librarian.contentType.file,
            contentId = item.fileid;
        if (item.slideid > 0) {
            contentType = Librarian.contentType.slide;
            contentId = item.slideid;
            var parentContentId = item.fileid;
        }

        // We only had rules for files and slides, if this is neither then don't get rules
        if ((typeof contentId != "number") || (contentId <= 0)) {
            onComplete(item);
            return null;
        }

        // Pass views if we have them set to try and get meta for the gathered rule items
        var url = Librarian.path.getMethodUrl("getcrules") + "&out=ljson&cntid=" + contentId + "&cnttype=" + contentType;

        var getRules = function(url) {
            if (Librarian.search.viewNameByType) {
                if (Librarian.search.viewNameByType[Librarian.Search.outputTypes.SLIDES])
                    url += "&vname=" + Librarian.search.viewNameByType[Librarian.Search.outputTypes.SLIDES];
                if (Librarian.search.viewNameByType[Librarian.Search.outputTypes.FILES])
                    url += "&fvname=" + Librarian.search.viewNameByType[Librarian.Search.outputTypes.FILES];
            }

            var request = new Librarian.Request.JSON({
                url: url,
                onSuccess: function(json) {
                    // Save the rules, if there are any
                    if (json) {
                        item.ruleGroup = json.groupid;
                        item.orderindex = json.orderindex;
                        item.rules = json.rules;
                        item.ruleItems = json.items;
                        item.isDependent = json.isdependent;
                        item.isTrigger = json.istrigger;
                        item.isIntegrity = json.isintegrity;
                        item.isOrdering = json.isordering;
                        item.isGrouping = json.isgrouping;
                    }

                    onComplete(item);
                }
            });
            request.send();
            return request;
        }

        getRules(url);

        if (parentContentId && Librarian.cart.addFileGroupRulesFromSlide) {
            url = Librarian.path.getMethodUrl("getcrules") + "&out=ljson&cntid=" + parentContentId + "&cnttype=" + Librarian.contentType.file ;
            getRules(url);
        }
    }
});